import '../../css/pages/landing.scss';
import BasePage from './base';

class LandingPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
    }
}

new LandingPage();
